import styled from "styled-components";
import { FaDownload } from "react-icons/fa";
import { createStyledIcon } from "utils/iconUtils";

const DownloadIcon = createStyledIcon(FaDownload);

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 4rem 2rem;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 1rem;
`;

export const Subtitle = styled.h2`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 3rem;
`;

export const ImageGrid = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const ImageBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImageStyled = styled.img`
  width: 100px;
  height: auto;
  margin-bottom: 1rem;
`;

export const DownloadBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const DownloadIconStyled = styled(DownloadIcon)`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.primary};
`;

export const DownloadTitle = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const DownloadVersion = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const Description = styled.p`
  max-width: 600px;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.secondary};
`;
